import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { createCustomMessage } from 'react-chatbot-kit';
import { useChatContext } from '../context/chat-context';


const ActionProvider = ({ createChatBotMessage, setState, children, state }) => {

  // console.log('ActionProvider state:', state);
  // console.log('ActionProvider chat context', useChatContext())

  const {setIsSending, lastMessage} = useChatContext();

  const customerDoc = () => {
    const customerDocMessage = createChatBotMessage(
      "Please input your document",
      {
        widget: 'customerDocPicture',
      }
    );

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, customerDocMessage],
    }));
  }

  const handleHello = () => {
    const botMessage = createChatBotMessage('Hello. Nice to meet you.');

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));

    setIsSending(false);
  };

  const typingMessage = () => {

    const botMessage = createCustomMessage(
      'q:start',
      "custom",
      // {
      //   widget: 'dogPicture',
      // }
    );

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));

    // setIsSending(false);
  }

  const handleDog = () => {
    const botMessage = createChatBotMessage(
      "Here's a nice dog picture for you!",
      {
        widget: 'dogPicture',
      }
    );

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, botMessage],
    }));

    setIsSending(false);
  };

  return (
    <div>
      {React.Children.map(children, (child) =>
        React.cloneElement(child, {
          actions: {
            handleHello,
            handleDog,
            typingMessage,
            customerDoc,
          },
        })
      )}
    </div>
  );
};

export default ActionProvider;

ActionProvider.propTypes = {
  createChatBotMessage: PropTypes.func,
  setState: PropTypes.func,
  children: PropTypes.node,
  state: PropTypes.object,
}
